import React, { useState, useEffect, useContext } from 'react';
import { endpoints } from '../../../../config/connections'
import callApi from '../../../components/utilities/callApi';
import USBDatePicker from '@usb-shield/react-date-picker';
import { defaultCalendarSettings } from '@usb-shield/react-calendar';
import {
  USBGrid,
  USBColumn,
  USBButton,
  USBSelect,
} from '@usb-shield/components-react';
import { USBTableCompat as USBTable } from '../../../components/shared/Table';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import Loader from '../../../components/utilities/Loader';
import './enrollment.css';
import '@usb-shield/react-forms-base/dist/library/styles/index.css';
import {ExportToExcel} from '../../../components/utilities/ExportToExcel';
// Update the import path to match the actual file location and name (case-sensitive)
import useUserRole from '../../../components/Hooks/use-UserRole';
import _noaccess from '../../../pages/_noaccess';
import Select from 'react-select'
import { FeatureFlagsContext } from '../../../components/Hooks/useFeatureFlags';
import moment from 'moment';


const EnrollmentReport = () => {
  const { featureDetails } = useContext(FeatureFlagsContext);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);
  const [userData, setUserData] = useState([]);
  const [parentCompanyData, setParentCompanyData] = useState([]);
  const [enrollmentDateFrom , setEnrollmentDateFrom] = useState('');
  const [enrollmentDateTo , setEnrollmentDateTo] = useState('');
  const [originalReportData, setOriginalReportData] = useState([]);
  const [filters, setFilters] = useState({
    userName: '',
    parentCompanyName: '',
    dateAdded: '',
    creationDate: '',
  });

  const loadReportData = (responseArray) => {
    setReportData(responseArray);
    setOriginalReportData(responseArray);
    tableData();
  };

  const clearFilter = async() => {
    setClearFilterFlag(true);
    setFilters({ userName: '', parentCompanyName: '', dateAdded: '', creationDate: '' });
    await getReportAPIResponse();
    setClearFilterFlag(false)
    window.location.assign('/Reports/enrollmentReport');
  };

  const getReportAPIResponse = async () => {
    setLoading(true);
    
    let apiURLFirst = '';
    apiURLFirst = `${endpoints.apigee}/document-management/coreservice/user-management/v1/allUsers/details`;
    
    try{
      const response = await callApi.getApiData(apiURLFirst);
      if(response){
         const userOptions = response.data.map(user => ({
          value: `${user.firstName} ${user.lastName}`,
          label: `${user.firstName} ${user.lastName}`
        }));
        const parentCompanyOptions = response.data.map(user => ({
          value: user.parentCompanyName,
          label: user.parentCompanyName
        }));
        const uniqueUsers = response.data.filter(
          (user, index, self) =>
            index === self.findIndex(
              (u) => u.email && user.email && u.email.toLowerCase() === user.email.toLowerCase()
            )
        );
        setOriginalReportData(uniqueUsers);
        setReportData(uniqueUsers);
       
        
        // Filter duplicate usernames by keeping only unique full names
        const uniqueUserOptions = userOptions.filter(
          (option, index, self) =>
            index === self.findIndex((o) => o.value === option.value)
        );
        setUserData(uniqueUserOptions);
        // Filter duplicate parent company names by keeping only unique names
        const uniqueParentCompanyOptions = parentCompanyOptions.filter(
          (option, index, self) =>
            index === self.findIndex((o) => o.value === option.value)
        );
        setParentCompanyData(uniqueParentCompanyOptions);
        loadReportData(uniqueUsers);
        setLoading(false);
      }
    }catch{
      setLoading(false);
    }
    
  };

  useEffect(() => {
    getReportAPIResponse();
  }, []);

  const defaultSettingsDateInput = {
    initValue: undefined,
    isDateOfBirth: true,
    // minimumAge: 0,
    // maximumAge: 10,
    // maxlength: 10,
    showRenderCount: false,
    inputName: 'date-picker_single-date--default',
    isDisabled: false,
    isOptional: false,
    isReadOnly: false,
    dataTestId: null,
  };

  const defaultSettingsCalendar = {
    areBankHolidaysDisabled: defaultSettingsDateInput.isDateOfBirth
      ? false
      : true,
    areWeekendsDisabled: defaultSettingsDateInput.isDateOfBirth ? false : true,
    occurrence: 'both',
    numberOfYearsToShow: '10',
  };
  const defaultContent1 = {
    dateInput: {
      calendarButtonAriaLabel: 'Choose date',
      helperText: 'mm/dd/yyyy',
      helperTextOptional: 'Optional',
      labelText: ' Ad Hoc Enrollment Date ',
      errorMessages: {
        default: 'Please enter a valid date.',
        118: 'Please enter a valid date.',
        201: 'Please enter a valid date.',
        202: 'Date should be in the past.',
        203: 'Date should be in the future.',
        221: 'Enter no more than 10 characters.',
        213: 'Enter numbers only.',
        224: '(Optional field)',
        228: "That date isn't available. Please try again.",
      },
    },
  };

  const defaultContent2 = {
    dateInput: {
      calendarButtonAriaLabel: 'Choose date',
      helperText: 'mm/dd/yyyy',
      helperTextOptional: 'Optional',
      labelText: 'Created Date',
      errorMessages: {
       default: 'Please enter a valid date.',
        118: 'Please enter a valid date.',
        201: 'Please enter a valid date.',
        202: 'Date should be in the past.',
        203: 'Date should be in the future.',
        221: 'Enter no more than 10 characters.',
        213: 'Enter numbers only.',
        224: '(Optional field)',
        228: "That date isn't available. Please try again.",
      },
    },
  };

 
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const javaDateRegex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{2}:\d{2}:\d{2} [A-Z]{3,} \d{4}$/;
    if (javaDateRegex.test(dateStr)) {
      return moment(dateStr, "ddd MMM DD HH:mm:ss [IST] YYYY");
    }
    return moment(dateStr);
  };

  const formatDate = (dateStr) => {
    const parsed = parseDate(dateStr);
    if (!parsed || !parsed.isValid()) return 'NA';
    return parsed.format('MM/DD/YYYY');
  };

  const applyAllFilters = (updatedFilters) => {
    const filteredData = originalReportData.filter(item => {
      if (updatedFilters.userName) {
        const fullName = `${item.firstName} ${item.lastName}`;
        if (fullName.toLowerCase() !== updatedFilters.userName.toLowerCase()) return false;
      }
      if (updatedFilters.parentCompanyName) {
        if (item.parentCompanyName !== updatedFilters.parentCompanyName) return false;
      }
      if (updatedFilters.dateAdded) {
        if (formatDate(item.adHocEnrollmentDetails?.dateAdded) !== updatedFilters.dateAdded) return false;
      }
      if (updatedFilters.creationDate) {
        if (formatDate(item.creationDate) !== updatedFilters.creationDate) return false;
      }
      return true;
    });
    setReportData(filteredData);
  };

  const updateData = (event, column) => {
    const dataValue = event ? event.inputValue : '';
    const filterValue = event ? event.value : '';

    const newFilters = { ...filters };
    if (column === 'userName') {
      newFilters.userName = filterValue;
    } else if (column === 'parentCompanyName') {
      newFilters.parentCompanyName = filterValue;
    } else if (column === 'creationDate') {
      const isValidDate = dataValue && moment(dataValue, 'MM/DD/YYYY', true).isValid();
      newFilters.creationDate = isValidDate ? dataValue : '';
    } else if (column === 'dateAdded') {
      const isValidDate = dataValue && moment(dataValue, 'MM/DD/YYYY', true).isValid();
      newFilters.dateAdded = isValidDate ? dataValue : '';
    }
    setFilters(newFilters);
    applyAllFilters(newFilters);
  };

  const tableData = () => {
    const tempData = [];
    reportData.forEach((item) => {
      tempData.push({
        first: item.firstName + ' ' + item.lastName,
        second: item.parentCompanyName && item.parentCompanyName.length > 0 ? item.parentCompanyName : 'NA',
        third: item.email && item.email != 0 ? item.email : 'NA',
        fourth: item.createdBy && item.createdBy != 0 ? item.createdBy.split('@')[0] + "-" + (item.addedByUser ? item.addedByUser : 'NA') : 'NA',
        fifth: item.adHocEnrollmentDetails?.dateAdded
          ? formatDate(item.adHocEnrollmentDetails.dateAdded)
          : 'NA',
        sixth: formatDate(item.creationDate),
        seventh: item.adHocEnrollmentDetails?.verifiedBy && item.adHocEnrollmentDetails?.verifiedBy != 0
          ? item.adHocEnrollmentDetails.verifiedBy
          : 'NA',
        eighth: item.adHocEnrollmentDetails?.adHocEnrolledFlag ? 'YES' : 'NO',
      });
    });
    return tempData;
  };

   
  const tempUserRole = useUserRole();
 
  
  return (
    tempUserRole && tempUserRole!="employee" && featureDetails.includes('feature_enrollment_report') ? <_noaccess/> :
    <>
      <USBGrid addClasses="content-frame">
        <USBColumn largeSpan={8}>
          <USBBreadcrumb
            id="enrollmentReportBreadcrumb"
            text="Enrollment Report"
            breadcrumbs={[
              { id: 1, text: 'Reports', href: '/Reports/Enrollment' },
              { id: 2, text: 'Enrollment', href: '' },
            ]}
          />
        </USBColumn>
        <USBColumn largeSpan={8}></USBColumn>
      </USBGrid>
      <USBGrid addClasses="content-frame content-bg-portal">
        {loading ? <Loader /> : null}
        <USBColumn largeSpan={16}>
          <h1 className="heading-h1">Report: Enrollment User</h1>
          <div className="page-details-wrap-portal">
          </div>
          { !clearFilterFlag ?
          <div className="sorting-inputs-portal ">
            <div className="filter-by-portal">Filter by :</div>
            <div className="filter-dropdowns-portal-enrollment portal-accordions">
            <h1>Search by user :</h1>
            <Select onChange={(e) => {
                  if (!e) {
                    const newFilters = { ...filters, userName: '' };
                    setFilters(newFilters);
                    applyAllFilters(newFilters);
                  } else {
                    updateData(e, 'userName');
                  }
                }}
                 options={userData}
                 placeholder="User Name"
                 name='userName'
                 isClearable
                 isSearchable />
            </div>

            <div className="filter-dropdowns-portal-enrollment portal-accordions">

              <h1>Parent Company :</h1>
               <Select onChange={(e) => {
                  if (!e) {
                    const newFilters = { ...filters, parentCompanyName: '' };
                    setFilters(newFilters);
                    applyAllFilters(newFilters);
                  } else {
                    updateData(e, 'parentCompanyName');
                  }
                }}
                 options={parentCompanyData}
                 placeholder="Parent Company"
                 name='parentCompanyName'
                 isClearable
                 isSearchable />
            </div>
                <div className="filter-dropdowns-portal-enrollment portal-From-datepickers">
                <USBDatePicker
                  id="asofdate"
                  inputName="asofdate"
                  labelText2="Enrollment Date"
                  statusUpdateCallback={(e) => {
                    setEnrollmentDateFrom(e.inputValue);
                    updateData(e, 'dateAdded');
                  }}
                  settings={{
                    dateInput: {
                      ...defaultSettingsDateInput,
                    },
                    calendar: {
                      id: 'datepicker',
                      ...defaultCalendarSettings,
                      ...defaultSettingsCalendar,
  
                      occurrence: 'past',
                      numberOfYearsToShow: '10',
                      labelText: 'Enrollment Date',
                    },
                  }}
                  content={{
                    ...defaultContent1,
                    labelText: 'Start date',
                    inputName: 'asofdate',
                  }}
                />
              </div>
              <div className="filter-dropdowns-portal-enrollment portal-to-datepickers">
                <USBDatePicker
                  id="submitteddate"
                  inputName="submitteddate"
                  initValue={moment().format('MMM DD, YYYY')}
                  labelText="Created Date"
                  statusUpdateCallback={(e) => {
                    setEnrollmentDateTo(e.inputValue);
                    updateData(e, 'creationDate');
                  }}
                  settings={{
                    dateInput: {
                      ...defaultSettingsDateInput,
                    },
                    calendar: {
                      id: 'datepicker',
                      ...defaultCalendarSettings,
                      ...defaultSettingsCalendar,
                      occurrence: 'past',
                      numberOfYearsToShow: '10',
                      labelText: 'Created Date',
                    },
                  }}
                  content={{
                    ...defaultContent2,
                    labelText: 'Start date',
                    inputName: 'submitteddate',
                  }}
                />
              </div> 
          </div>
           : null }
          <div className="actionButtons-portal">
            <div>
              <USBButton
                id="clearfilterPortal"
                name="clearfilter"
                handleClick={() => {
                  clearFilter();
                }}
              >
                Clear filters
              </USBButton>
            </div>
            <div>
              <USBButton
                id="downloadReportPortal"
                name="downloadReport"
                variant="primary"
                handleClick={() => {
                 const excelData = [];
                  const filterSelections = '';
                  if (reportData) {
                    reportData.forEach((item, index) => {
                      if (index == 0) {
                        excelData.push(
                          // {
                          //   '': filterSelections,
                          // },
                          // { '': '' },
                          {
                            '': 'User Name',
                            ' ': 'Parent company',
                            '  ': 'Email ',
                            '   ': 'Added By User',
                            '    ': 'Enrollment Date',
                            '     ': 'Created Date',
                            '      ': 'Verification Performed By',
                            '       ': 'Ad Hoc Enrollment',
                          }
                        );
                      }
                      excelData.push({
                        '': item.firstName + ' ' + item.lastName ,
                        ' ': item.parentCompanyName,
                        '  ': item.email,
                        '   ': item.createdBy,
                        '    ': item.adHocEnrollmentDetails?.dateAdded,
                        '     ': moment(item.creationDate).format('MM/DD/YYYY') ? moment(item.creationDate).format('MM/DD/YYYY') : 'NA',
                        '      ': item.adHocEnrollmentDetails?.verifiedBy,
                        '       ': item.adHocEnrollmentDetails?.adHocEnrolledFlag ? 'YES' : 'NO',
                      });
                    });
                  } else {
                    excelData.push({
                      '': 'NA',
                      ' ': 'NA',
                      '  ': 'NA',
                      '   ': 'NA',
                      '    ': 'NA',
                      '     ': 'NA',
                      '      ': 'NA',
                      '       ': 'NA',
                    });
                  }
                  ExportToExcel(
                    Object.values(excelData),
                    'Enrollment User ' +
                      moment().format('MMM DD, YYYY'),
                    ()=>{},
                    ()=>{}
                  );
                }}
              >
                Download Report
              </USBButton>
            </div>
          </div>
          {!loading && !clearFilterFlag? (
            <div className="page-content-portal">

              {reportData.length > 0 ? 
              <USBTable
                columnData={[
                  {
                    headerName: 'User Name',
                    fieldFor: 'first',
                    dataType: 'string',
                    type: 'info',
                  },
                  {
                    headerName: 'Parent company',
                    fieldFor: 'second',
                    dataType: 'string',
                    type: 'default',
                  },
                  {
                    headerName: 'Email',
                    fieldFor: 'third',
                    dataType: 'string',
                    type: 'default',
                  },
                  {
                    headerName: 'Added By User',
                    fieldFor: 'fourth',
                    dataType: 'string',
                    type: 'default',
                  },
                  {
                    headerName: 'Ad Hoc Enrollment Date',
                    fieldFor: 'fifth',
                    dataType: 'string',
                    type: 'default',
                  },{
                    headerName: 'Created Date',
                    fieldFor: 'sixth',
                    dataType: 'string',
                    type: 'default',
                  },{
                    headerName: 'Verification Performed By',
                    fieldFor: 'seventh',
                    dataType: 'string',
                    type: 'default',
                  },
                  {
                    headerName: 'Ad Hoc Enrolled',
                    fieldFor: 'eighth',
                    dataType: 'string',
                    type: 'default',
                  }
                ]}
                tableData={
                  reportData && reportData.length > 0
                    ? tableData()
                    : [
                        {
                          first: 'NA',
                          second: 'NA',
                          third: 'NA',
                          fourth: 'NA',
                          fifth: 'NA',
                          sixth: 'NA',
                          seventh: 'NA',
                          eighth: 'NA',
                        },
                      ]
                }
                displayVariant="auto"
              /> :
              <div className='no-records-message'>
                <p>No records found. Please adjust your filters or select a different category.</p>
              </div>}
            </div>
          ) : (
            null
          )}
        </USBColumn>
      </USBGrid>
    </>
  );
};

export default EnrollmentReport;;